// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"Home_mainContent__29Pw1"};